<script setup lang="ts">
import AutocompleteField from '@/components/Selector/AutocompleteField.vue'
import type { CheckpointModel } from '@/types/models/CheckpointModel'
import { computed } from 'vue'

type Props = {
    inputValue?: string
    poiId?: number
    checkpoint?: Partial<CheckpointModel>
    checkpointOptions: CheckpointModel[]
    isLoadingCheckpoints?: boolean
    disabled?: boolean
}
const props = defineProps<Props>()
type Emits = {
    (e: 'typing', value?: string): void
    (e: 'select', value: CheckpointModel | undefined, event: PointerEvent): void
}
defineEmits<Emits>()

const localCheckpointOptions = computed<Partial<CheckpointModel>[]>(() =>
    props.checkpoint && !props.checkpointOptions.find(item => item.id === props.checkpoint?.id)
        ? [props.checkpoint, ...props.checkpointOptions]
        : props.checkpointOptions
)
</script>

<template>
    <AutocompleteField
        :label="$t('device.filters.checkpoint')"
        :modelValue="
            inputValue ??
            checkpoint?.name ??
            checkpointOptions.find(item => item.id === poiId)?.name
        "
        :loading="isLoadingCheckpoints"
        @typing="$emit('typing', $event)"
        @select="(value, event) => $emit('select', value as CheckpointModel, event)"
        :options="localCheckpointOptions"
        :disabled="disabled" />
</template>
